import MicroModal from 'micromodal';
import { getURLParameter } from '../utils';

export default class GatedContent {
    init() {
        console.info('GatedContent.init()');

        if(!document.getElementById('single-recipe')){
            return;
        }
        const disabled = Boolean(Number(document.getElementById('single-recipe').getAttribute('data-disable-gating')));
        if (getURLParameter('gated') === 'true' && !disabled) {
            this.show();
        }
    }

    show(){
        if (!CLWP_PC_GLOBAL.isLoggedIn) {
            const customShowModal = (modalId, options) => {
                // Show the modal using MicroModal
                MicroModal.show(modalId, options);

                // Keydown event handler
                const keydownHandler = (event) => {
                    if (event.key === 'Escape' || event.keyCode === 27) {
                        // Prevent closing the modal on ESC
                        event.stopPropagation();
                        event.preventDefault(); // Prevent default behavior
                    }
                };

                // Add keydown listener to the document
                document.addEventListener('keydown', keydownHandler, true);
            }

            setTimeout(() => {
                customShowModal('modal-gated-content--signup', {
                    onShow: (modal) => console.info(`${modal.id} is shown`),
                    onClose: (modal) => console.log(`${modal.id} is hidden`),
                    disableScroll: true,
                    disableFocus: true,
                    closeTrigger: 'data-custom-close'
                });
            }, 1000);
        }

    }
}
